// extracted by mini-css-extract-plugin
export default {"OurPurpose":"OurPurpose_OurPurpose__JVYsa"};